var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEtfHero = function SvgEtfHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7926,
    height: 1991,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "etf-hero_svg__a",
    width: 7926,
    height: 1991,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h7926v1991H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#etf-hero_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__b)",
    d: "M5687.5 1494.6c-87.3 0-158.1 70.8-158.1 158.1 0 87.4 70.8 158.2 158.1 158.2h688.6c43.6 0 83.2-17.7 111.8-46.4 28.6-28.6 46.3-68.1 46.3-111.8 0-87.3-70.8-158.1-158.1-158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__c)",
    d: "M5761.9 1829.5c0 87.3 70.7 158.1 158.1 158.1h722.8c43.6 0 83.2-17.7 111.8-46.3s46.3-68.1 46.3-111.8c0-87.3-70.8-158.1-158.1-158.1H5920c-87.4 0-158.1 70.8-158.1 158.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__d)",
    d: "M1767.4 1569c-31.3 0-59.6 12.7-80.2 33.2-20.5 20.6-33.2 48.9-33.2 80.2 0 62.6 50.8 113.4 113.4 113.4h493.7c62.6 0 113.4-50.8 113.4-113.4s-50.8-113.4-113.4-113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__e)",
    d: "M1496 1475.5c-20.5 20.5-33.2 48.9-33.2 80.2 0 62.6 50.7 113.4 113.4 113.4h518.2c62.7 0 113.4-50.8 113.4-113.4s-50.7-113.4-113.4-113.4h-518.2c-31.4 0-59.7 12.7-80.2 33.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2E35",
    d: "M5071.2 1436.6c-14.1-68.6-35.4-134.7-62.9-197.9-29.3-67.1-65.7-130.8-108.5-190.2-41.4-57.3-88.6-110.7-140.9-159.4-50.8-47.2-106.3-89.8-165.8-127.4-61-38.5-126.2-71.7-194.9-98.7-70.5-27.7-144.7-48.9-221.7-63-71.4-13.1-145.2-20.101-220.8-20.101-73.2 0-144.8 6.7-214.1 19-73.8 13.1-145.1 32.801-213 58.401-72.1 27.3-140.7 61.1-204.6 100.8-61.7 38.5-119.2 82.3-171.5 131-50.7 47.1-96.7 98.7-137.1 154.1-41.5 56.7-77.2 117.3-106.2 181.2-29.9 65.5-52.6 134.4-67.8 205.9-14.1 66.4-21.6 135-21.6 205.3 0 68.1 7.1 134.6 20.4 199 14 68.5 35.3 134.7 62.9 197.9 29.3 67.1 65.6 130.8 108.4 190.2 41.4 57.4 88.5 110.8 141 159.4 50.7 47.2 106.2 89.8 165.7 127.4 61.1 38.5 126.3 71.6 195 98.7 70.5 27.8 144.6 48.9 221.5 63a1226 1226 0 0 0 221 20.1c73.2 0 144.7-6.6 214-18.9 73.8-13.1 145.1-32.9 212.9-58.5 72.3-27.2 140.8-61 204.8-100.8 61.6-38.5 119.2-82.3 171.5-131 50.7-47.1 96.6-98.7 137-154 41.5-56.8 77.3-117.4 106.3-181.2 29.8-65.6 52.6-134.5 67.7-205.9 14.1-66.5 21.6-135.1 21.6-205.4 0-68.1-7.1-134.5-20.3-199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__f)",
    d: "M6631.8 388.699 6050.7 653.5c-35.1 16-60.4 44.7-72.9 78.2s-12.3 71.8 3.7 106.9c32 70.2 114.9 101.099 185.1 69.199L6747.7 643c70.2-32 101.2-114.901 69.2-185.101-23.5-51.4-74.2-81.799-127.2-81.799-19.4 0-39.1 4.099-57.9 12.599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__g)",
    d: "m3707.2 340.899 64 333.5c59.7-11.4 121.3-17.599 184.5-17.599V317.399c-85 0-168.1 8.1-248.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__h)",
    d: "m2864.5 895.9 280.9 190.4c34.9-51.3 74.4-99.1 118.1-142.8l-239.9-240c-58.9 58.9-112.2 123.3-159.1 192.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__i)",
    d: "M4916.9 1451.1c11.4 59.8 17.6 121.4 17.6 184.5h339.4c0-85-8.2-168-23.5-248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__j)",
    d: "M4504.9 825.399c51.3 34.8 99.2 74.4 142.9 118l240-239.899c-58.9-58.9-123.3-112.101-192.4-159.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__k)",
    d: "m2995.5 1445.2 498.1 98.8c6.3-31.9 15.8-62.7 28.1-91.9l-467.8-197.8c-25.7 60.8-45.3 124.6-58.4 190.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__l)",
    d: "m3411.3 822.1 282.4 422c26.5-17.7 55-32.8 84.9-45l-190.9-470.5c-62.2 25.2-121.3 56.5-176.4 93.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__m)",
    d: "M4347.1 1373.7c17.8 26.5 32.9 54.9 45.1 84.8l470.5-190.9c-25.2-62.2-56.6-121.2-93.5-176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__n)",
    d: "M4047.3 1173.6c31.8 6.3 62.6 15.7 91.8 28l197.8-467.801c-60.7-25.7-124.6-45.3-190.9-58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__o)",
    d: "m4389.6 1819.1 467.8 197.8c25.8-60.8 45.4-124.7 58.4-190.9l-498.1-98.8c-6.3 31.9-15.7 62.6-28.1 91.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__p)",
    d: "M3048.6 2003.6c25.3 62.2 56.6 121.2 93.5 176.3l422.1-282.4c-17.8-26.5-32.8-54.9-45-84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__q)",
    d: "m2666.2 1379.9 332 65.9c13.1-66.1 32.7-129.8 58.3-190.4l-311.8-131.8c-34.5 81.5-61 167.3-78.5 256.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__r)",
    d: "M4145.5 678.199c66.1 13 129.8 32.6 190.3 58.2L4467.7 424.6c-81.6-34.5-167.4-60.9-256.3-78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__s)",
    d: "m3224.7 543.1 188.2 281.299c54.9-36.8 113.8-67.999 175.8-93.199l-127.3-313.801c-83.5 33.9-162.8 76.101-236.7 125.701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__t)",
    d: "M4766.9 1092.8c36.8 55 68 113.9 93.2 175.9l313.8-127.3c-33.9-83.5-76.1-162.8-125.7-236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__u)",
    d: "m4854.8 2015.8 311.8 131.8c34.6-81.5 61-167.3 78.6-256.3l-332.1-65.9c-13 66.1-32.6 129.8-58.3 190.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__v)",
    d: "m3771.7 677.1 95.5 497.3c28.6-5.5 58.2-8.5 88.5-8.5V659.6c-63 0-124.4 6.2-184 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__w)",
    d: "m3147.8 1087.9 419.1 284.1c16.7-24.6 35.7-47.5 56.7-68.5l-358.1-358c-43.6 43.5-83 91.3-117.7 142.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__x)",
    d: "M4416.9 1547.1c5.5 28.6 8.4 58.2 8.4 88.5h506.4c0-62.9-6.2-124.4-17.6-184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__y)",
    d: "M4219.2 1246.8c24.6 16.8 47.6 35.7 68.6 56.7l358-358.1c-43.5-43.5-91.3-83-142.4-117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__z)",
    d: "m4287.8 1967.7 358 358.1c43.6-43.6 83-91.4 117.8-142.5l-419.2-284.1c-16.7 24.6-35.7 47.5-56.6 68.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__A)",
    d: "M2979.6 1635.6c0 62.9 6.2 124.4 17.6 184l497.3-95.5c-5.5-28.6-8.5-58.2-8.5-88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__B)",
    d: "M3265.5 2325.7c43.6 43.6 91.3 83.1 142.5 117.8l284.1-419.1c-24.6-16.8-47.6-35.7-68.5-56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__C)",
    d: "M3955.7 592.3c69.4 0 137.2 6.899 202.9 19.899l70.4-355c-88.4-17.4-179.8-26.599-273.3-26.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__D)",
    d: "m2962.2 642.1 255.7 255.8c48.1-48.1 100.9-91.4 157.6-129.4l-201.2-300.7c-76.4 51.1-147.4 109.5-212.1 174.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__E)",
    d: "M4999 1635.6c0 69.5-7 137.3-19.9 202.9l354.9 70.4c17.5-88.4 26.7-179.8 26.7-273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__F)",
    d: "M4693.4 897.899c48.1 48.1 91.4 100.8 129.4 157.501l300.7-201.2c-51.1-76.3-109.6-147.4-174.3-212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__G)",
    d: "M2550.6 1635.6h361.8c0-69.5 6.9-137.3 19.8-202.9l-354.9-70.4c-17.4 88.4-26.7 179.8-26.7 273.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__H)",
    d: "m3563.4 668.8 203.5 501.6c30-12.2 61.5-21.6 94.1-27.8l-102-531.5c-67.8 12.9-133.1 32.4-195.6 57.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__I)",
    d: "m2994.5 1229.2 498.7 210.8c12.8-30.3 28.6-59.2 46.9-86.1l-448-303.8c-38.1 56.1-70.9 116-97.6 179.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__J)",
    d: "M4420.9 1446.9c12.2 30 21.5 61.5 27.8 94.1l531.5-102.1c-12.9-67.7-32.4-133.1-57.8-195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__K)",
    d: "M4151.2 1173.1c30.4 12.8 59.2 28.6 86.2 46.9l303.7-448c-56-38.1-115.9-70.901-179.1-97.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__L)",
    d: "m4371.2 1917.3 448.1 303.8c38-56.1 70.8-116 97.5-179.1l-498.6-210.8c-12.8 30.3-28.7 59.2-47 86.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__M)",
    d: "M2931.1 1832.2c13 67.8 32.4 133.2 57.8 195.6l501.5-203.5c-12.1-30-21.5-61.5-27.7-94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__N)",
    d: "m3424.8 327.1 136.8 337c62.7-25.4 128.4-45 196.5-58l-68.6-357.201c-91.7 17.5-180.2 43.901-264.7 78.201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__O)",
    d: "m2655 1085.7 334.8 141.5c26.9-63.4 59.8-123.6 98.1-179.9l-300.9-204c-51.6 75.8-95.9 156.9-132 242.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__P)",
    d: "M4927.1 1241.5c25.5 62.7 45.1 128.4 58.1 196.5l357.1-68.6c-17.5-91.6-43.8-180.2-78.1-264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__Q)",
    d: "M4364 669.8c63.5 26.8 123.6 59.799 180 97.999l204-300.9c-75.9-51.5-157-95.9-242.4-132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__R)",
    d: "M2569 1901.8c17.5 91.7 43.8 180.2 78.1 264.6l337.1-136.7c-25.5-62.7-45-128.4-58.1-196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__S)",
    d: "M3955.7 1131.1c33.6 0 66.3 3.4 98.1 9.6l105.8-533.501c-66-13-134.1-20-203.9-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__T)",
    d: "M2907.3 1635.6h543.9c0-33.6 3.3-66.4 9.6-98.1l-533.5-105.8c-13 66-20 134.1-20 203.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__U)",
    d: "M4312.4 1278.9c23.2 23.2 44.2 48.8 62.6 76.2l452-302.5c-38.2-56.9-81.7-110-130-158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__V)",
    d: "m3214.3 894.3 384.7 384.6c23.2-23.3 48.7-44.2 76.1-62.6l-302.4-452c-57 38.1-110 81.7-158.4 130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__W)",
    d: "M4460.1 1635.6c0 33.6-3.3 66.4-9.6 98.1l533.6 105.8c13-65.9 19.9-134.1 19.9-203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__X)",
    d: "M3084.3 2218.6c38.2 56.9 81.8 110 130 158.3l384.7-384.6c-23.3-23.2-44.2-48.8-62.6-76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__Y)",
    d: "M6205.2 452.1c-15.5 7.6-21.9 26.2-14.4 41.7l15.6 32.1-32.1 15.6c-15.4 7.6-21.9 26.2-14.3 41.7 7.5 15.5 26.2 21.9 41.6 14.4l32.1-15.7 15.7 32.1c7.5 15.5 26.2 21.9 41.6 14.4 15.5-7.6 21.9-26.2 14.4-41.7l-15.6-32.1 32.1-15.6c15.4-7.6 21.9-26.2 14.3-41.7-7.5-15.5-26.2-21.9-41.6-14.4l-32.1 15.7-15.7-32.1c-5.4-11.1-16.5-17.5-28-17.5-4.6 0-9.3 1-13.6 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__Z)",
    d: "M4781.4 554.1c-18.5 18.6-18.5 48.6 0 67.1 18.6 18.6 48.6 18.6 67.1 0 18.6-18.5 18.6-48.5 0-67.1-9.2-9.2-21.4-13.8-33.5-13.8-12.2 0-24.3 4.6-33.6 13.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5845.2 1069.4c-44.3 0-80.1-35.8-80.1-80.1s35.8-80.1 80.1-80.1 80.1 35.8 80.1 80.1-35.8 80.1-80.1 80.1M4608.5 689.6c30.4 0 58.7 11.9 79.8 33.4 21 21.4 32.6 49.899 32.6 80.399V1194.9h-6V803.399c0-60.4-46.7-107.799-106.4-107.799-59.6 0-106.3 47.399-106.3 107.799V957.1l.8 58.9c0 44.6-36.1 80.8-80.5 80.8-44.5 0-80.7-36.2-80.7-80.8v-81.101c0-59.5-49.1-107.899-109.5-107.899s-109.6 48.399-109.6 107.899v1.201l1.4 312.9h-6l-1.4-314.101c0-62.8 51.9-113.899 115.6-113.899s115.5 51.099 115.5 113.899V1016c0 41.3 33.5 74.8 74.7 74.8 41.1 0 74.5-33.5 74.5-74.8l-.8-58.9V803.399c0-30.5 11.6-58.999 32.6-80.399 21.1-21.5 49.4-33.4 79.7-33.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aa)",
    d: "M2468.82 175.296h472.32v484.8h-472.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ab)",
    d: "M2629.9 228.1c-4.7 4.7-4.7 12.399 0 17.099l56.5 56.5 3.6 3.601 4.7 4.7c3.3 3.3 3.3 8.599 0 11.899s-8.7 3.3-12 0l-4.2-4.299-82.6-82.6c-4.7-4.7-12.3-4.7-17.1 0-4.7 4.7-4.7 12.3 0 17l89 89 2.9 2.899c3.3 3.3 3.3 8.6 0 12-3.3 3.2-8.7 3.3-12 0l-4.5-4.599-110-110c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17l110 110 7.5 7.5c3.4 3.3 3.4 8.7.1 12-3.4 3.3-8.7 3.3-12 0l-2.1-2.101-77.1-77.199c-4.7-4.7-12.4-4.7-17.1 0s-4.7 12.4 0 17.1l68.1 68 3.5 3.599a8.39 8.39 0 0 1 0 11.901 8.39 8.39 0 0 1-11.9 0l-6.8-6.8-46.1-46.101c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L2690.5 537.5c36.7 36.7 96.2 36.7 132.9 0s36.7-96.2 0-132.9l-176.5-176.5c-2.3-2.3-5.4-3.5-8.5-3.5s-6.2 1.2-8.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2717.9 509.8c-21.5-21.5-21.5-56.3 0-77.8s56.3-21.5 77.8 0 21.5 56.3 0 77.8-56.3 21.5-77.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ac)",
    d: "M2737.7 451.8c-10.5 10.5-10.5 27.599 0 38.099 10.6 10.6 27.6 10.6 38.2 0 10.5-10.5 10.5-27.599 0-38.099-5.3-5.2-12.2-7.901-19.1-7.901s-13.8 2.701-19.1 7.901"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ad)",
    d: "m1610.7 1171.9 357.1 151.2 2.3-5.6-357-151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ae)",
    d: "m1912.6 1189.4 52.4 129.2-129.3 52.4 2.3 5.6 134.8-54.7-54.6-134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3169.9 892.4c-12.1 0-23.5-4.6-32.2-13l-194.7-187c-8.9-8.6-14-20.2-14.2-32.6-.3-12.4 4.3-24.1 12.9-33 8.8-9.2 20.7-14.3 33.5-14.3 12 0 23.4 4.6 32.1 13l194.7 187c18.4 17.8 19 47.2 1.3 65.6-8.8 9.2-20.7 14.3-33.4 14.3m-194.7-273.9c-11.1 0-21.5 4.4-29.2 12.4-7.4 7.8-11.4 18-11.2 28.8s4.6 20.9 12.4 28.3l194.7 187.1c7.5 7.3 17.5 11.3 28 11.3 11 0 21.4-4.4 29.1-12.4 15.4-16.1 14.9-41.7-1.2-57.1l-194.7-187.1c-7.5-7.3-17.5-11.3-27.9-11.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2801.8 921.2c-51.4 0-93-41.6-93-93s41.6-93 93-93c51.5 0 93 41.6 93 93s-41.5 93-93 93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__af)",
    d: "M5296.5 254.199 5119.7 431.1c-11.2 11.2-16.8 25.899-16.8 40.599s5.6 29.401 16.8 40.601c22.4 22.4 58.8 22.4 81.2 0l176.9-176.8c22.4-22.5 22.4-58.801 0-81.301-11.2-11.2-25.9-16.8-40.6-16.8s-29.4 5.6-40.7 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ag)",
    d: "m5191.5 268.499-185.7 185.7c-11.2 11.2-16.8 25.9-16.8 40.6s5.6 29.4 16.8 40.6c22.5 22.4 58.8 22.4 81.2 0l185.7-185.6c22.4-22.5 22.4-58.8 0-81.3-11.2-11.2-25.9-16.8-40.6-16.8s-29.4 5.6-40.6 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ah)",
    fillRule: "evenodd",
    d: "M7597.5 1589.4c54.6 0 99.1 44.4 99.1 99.1 0 54.6-44.5 99.1-99.1 99.1h-418.6c-26.4 0-51.3-10.3-70-29-18.8-18.7-29.1-43.6-29.1-70.1s10.3-51.4 29.1-70.1c18.7-18.7 43.6-29 70-29zM7179 1781.6h418.5c51.4 0 93.2-41.8 93.2-93.1 0-51.4-41.8-93.1-93.2-93.1H7179c-24.9 0-48.2 9.7-65.8 27.2-17.6 17.6-27.3 41-27.3 65.9s9.7 48.2 27.3 65.8 40.9 27.3 65.8 27.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ai)",
    fillRule: "evenodd",
    d: "M1162.6 1569.2c54.7 0 99.1 44.5 99.1 99.1 0 54.7-44.4 99.2-99.1 99.2H744.1c-26.5 0-51.4-10.4-70.1-29.1s-29-43.6-29-70.1c0-26.4 10.3-51.3 29-70 18.7-18.8 43.6-29.1 70.1-29.1zM744 1761.5h418.6c51.3 0 93.1-41.8 93.1-93.2 0-51.3-41.8-93.1-93.1-93.1H744.1c-24.9 0-48.3 9.7-65.9 27.3s-27.3 41-27.3 65.8c0 24.9 9.7 48.3 27.3 65.9s41 27.3 65.8 27.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aj)",
    fillRule: "evenodd",
    d: "M6941.3 430.1c55.8 0 106.8 32.8 129.9 83.5 32.6 71.6.9 156.4-70.7 189.1L6447 954.899c-18.8 8.5-38.6 12.9-59.1 12.9-55.8 0-106.8-32.799-129.9-83.599-15.8-34.7-17.2-73.4-3.8-109.1 13.3-35.8 39.8-64.1 74.5-79.9L6882.2 443c18.8-8.6 38.6-12.9 59.1-12.9m-553.4 531.699c19.6 0 38.6-4.2 56.6-12.4L6998 697.2c68.6-31.3 99-112.5 67.8-181.1-22.2-48.6-71.1-80-124.5-80-19.6 0-38.6 4.099-56.6 12.299L6331.2 700.6c-33.3 15.2-58.6 42.3-71.4 76.6-12.8 34.2-11.5 71.3 3.6 104.5 22.2 48.6 71.1 80.099 124.5 80.099",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3552.2 1187.6v194.6h76.2v87.5c0 14.9 12.5 27 27.5 27 14.9 0 27.4-12.1 27.4-27V1446l-.3-21.6c0-10.4 8.4-18.9 18.8-18.9 10.5 0 19.1 8.5 19.1 18.9v18.6c0 14.9 11.8 27 26.7 27s26.7-12.1 26.7-27v-42.7c0-8.6 6.1-15.8 14.1-18.1h45.3v732.9h227v-732.9h281.5v-194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ak)",
    d: "M5687.5 1494.6c-87.3 0-158.1 70.8-158.1 158.1 0 87.4 70.8 158.2 158.1 158.2h688.6c43.6 0 83.2-17.7 111.8-46.4 28.6-28.6 46.3-68.1 46.3-111.8 0-87.3-70.8-158.1-158.1-158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__al)",
    d: "M5761.9 1829.5c0 87.3 70.7 158.1 158.1 158.1h722.8c43.6 0 83.2-17.7 111.8-46.3s46.3-68.1 46.3-111.8c0-87.3-70.8-158.1-158.1-158.1H5920c-87.4 0-158.1 70.8-158.1 158.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__am)",
    d: "M1767.4 1569c-31.3 0-59.6 12.7-80.2 33.2-20.5 20.6-33.2 48.9-33.2 80.2 0 62.6 50.8 113.4 113.4 113.4h493.7c62.6 0 113.4-50.8 113.4-113.4s-50.8-113.4-113.4-113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__an)",
    d: "M1496 1475.5c-20.5 20.5-33.2 48.9-33.2 80.2 0 62.6 50.7 113.4 113.4 113.4h518.2c62.7 0 113.4-50.8 113.4-113.4s-50.7-113.4-113.4-113.4h-518.2c-31.4 0-59.7 12.7-80.2 33.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2E35",
    d: "M5071.2 1436.6c-14.1-68.6-35.4-134.7-62.9-197.9-29.3-67.1-65.7-130.8-108.5-190.2-41.4-57.3-88.6-110.7-140.9-159.4-50.8-47.2-106.3-89.8-165.8-127.4-61-38.5-126.2-71.7-194.9-98.7-70.5-27.7-144.7-48.9-221.7-63-71.4-13.1-145.2-20.101-220.8-20.101-73.2 0-144.8 6.7-214.1 19-73.8 13.1-145.1 32.801-213 58.401-72.1 27.3-140.7 61.1-204.6 100.8-61.7 38.5-119.2 82.3-171.5 131-50.7 47.1-96.7 98.7-137.1 154.1-41.5 56.7-77.2 117.3-106.2 181.2-29.9 65.5-52.6 134.4-67.8 205.9-14.1 66.4-21.6 135-21.6 205.3 0 68.1 7.1 134.6 20.4 199 14 68.5 35.3 134.7 62.9 197.9 29.3 67.1 65.6 130.8 108.4 190.2 41.4 57.4 88.5 110.8 141 159.4 50.7 47.2 106.2 89.8 165.7 127.4 61.1 38.5 126.3 71.6 195 98.7 70.5 27.8 144.6 48.9 221.5 63a1226 1226 0 0 0 221 20.1c73.2 0 144.7-6.6 214-18.9 73.8-13.1 145.1-32.9 212.9-58.5 72.3-27.2 140.8-61 204.8-100.8 61.6-38.5 119.2-82.3 171.5-131 50.7-47.1 96.6-98.7 137-154 41.5-56.8 77.3-117.4 106.3-181.2 29.8-65.6 52.6-134.5 67.7-205.9 14.1-66.5 21.6-135.1 21.6-205.4 0-68.1-7.1-134.5-20.3-199"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ao)",
    d: "M6631.8 388.699 6050.7 653.5c-35.1 16-60.4 44.7-72.9 78.2s-12.3 71.8 3.7 106.9c32 70.2 114.9 101.099 185.1 69.199L6747.7 643c70.2-32 101.2-114.901 69.2-185.101-23.5-51.4-74.2-81.799-127.2-81.799-19.4 0-39.1 4.099-57.9 12.599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ap)",
    d: "m3707.2 340.899 64 333.5c59.7-11.4 121.3-17.599 184.5-17.599V317.399c-85 0-168.1 8.1-248.5 23.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aq)",
    d: "m2864.5 895.9 280.9 190.4c34.9-51.3 74.4-99.1 118.1-142.8l-239.9-240c-58.9 58.9-112.2 123.3-159.1 192.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ar)",
    d: "M4916.9 1451.1c11.4 59.8 17.6 121.4 17.6 184.5h339.4c0-85-8.2-168-23.5-248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__as)",
    d: "M4504.9 825.399c51.3 34.8 99.2 74.4 142.9 118l240-239.899c-58.9-58.9-123.3-112.101-192.4-159.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__at)",
    d: "m2995.5 1445.2 498.1 98.8c6.3-31.9 15.8-62.7 28.1-91.9l-467.8-197.8c-25.7 60.8-45.3 124.6-58.4 190.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__au)",
    d: "m3411.3 822.1 282.4 422c26.5-17.7 55-32.8 84.9-45l-190.9-470.5c-62.2 25.2-121.3 56.5-176.4 93.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__av)",
    d: "M4347.1 1373.7c17.8 26.5 32.9 54.9 45.1 84.8l470.5-190.9c-25.2-62.2-56.6-121.2-93.5-176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aw)",
    d: "M4047.3 1173.6c31.8 6.3 62.6 15.7 91.8 28l197.8-467.801c-60.7-25.7-124.6-45.3-190.9-58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ax)",
    d: "m4389.6 1819.1 467.8 197.8c25.8-60.8 45.4-124.7 58.4-190.9l-498.1-98.8c-6.3 31.9-15.7 62.6-28.1 91.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ay)",
    d: "M3048.6 2003.6c25.3 62.2 56.6 121.2 93.5 176.3l422.1-282.4c-17.8-26.5-32.8-54.9-45-84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__az)",
    d: "m2666.2 1379.9 332 65.9c13.1-66.1 32.7-129.8 58.3-190.4l-311.8-131.8c-34.5 81.5-61 167.3-78.5 256.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aA)",
    d: "M4145.5 678.199c66.1 13 129.8 32.6 190.3 58.2L4467.7 424.6c-81.6-34.5-167.4-60.9-256.3-78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aB)",
    d: "m3224.7 543.1 188.2 281.299c54.9-36.8 113.8-67.999 175.8-93.199l-127.3-313.801c-83.5 33.9-162.8 76.101-236.7 125.701"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aC)",
    d: "M4766.9 1092.8c36.8 55 68 113.9 93.2 175.9l313.8-127.3c-33.9-83.5-76.1-162.8-125.7-236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aD)",
    d: "m4854.8 2015.8 311.8 131.8c34.6-81.5 61-167.3 78.6-256.3l-332.1-65.9c-13 66.1-32.6 129.8-58.3 190.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aE)",
    d: "m3771.7 677.1 95.5 497.3c28.6-5.5 58.2-8.5 88.5-8.5V659.6c-63 0-124.4 6.2-184 17.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aF)",
    d: "m3147.8 1087.9 419.1 284.1c16.7-24.6 35.7-47.5 56.7-68.5l-358.1-358c-43.6 43.5-83 91.3-117.7 142.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aG)",
    d: "M4416.9 1547.1c5.5 28.6 8.4 58.2 8.4 88.5h506.4c0-62.9-6.2-124.4-17.6-184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aH)",
    d: "M4219.2 1246.8c24.6 16.8 47.6 35.7 68.6 56.7l358-358.1c-43.5-43.5-91.3-83-142.4-117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aI)",
    d: "m4287.8 1967.7 358 358.1c43.6-43.6 83-91.4 117.8-142.5l-419.2-284.1c-16.7 24.6-35.7 47.5-56.6 68.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aJ)",
    d: "M2979.6 1635.6c0 62.9 6.2 124.4 17.6 184l497.3-95.5c-5.5-28.6-8.5-58.2-8.5-88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aK)",
    d: "M3265.5 2325.7c43.6 43.6 91.3 83.1 142.5 117.8l284.1-419.1c-24.6-16.8-47.6-35.7-68.5-56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aL)",
    d: "M3955.7 592.3c69.4 0 137.2 6.899 202.9 19.899l70.4-355c-88.4-17.4-179.8-26.599-273.3-26.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aM)",
    d: "m2962.2 642.1 255.7 255.8c48.1-48.1 100.9-91.4 157.6-129.4l-201.2-300.7c-76.4 51.1-147.4 109.5-212.1 174.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aN)",
    d: "M4999 1635.6c0 69.5-7 137.3-19.9 202.9l354.9 70.4c17.5-88.4 26.7-179.8 26.7-273.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aO)",
    d: "M4693.4 897.899c48.1 48.1 91.4 100.8 129.4 157.501l300.7-201.2c-51.1-76.3-109.6-147.4-174.3-212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aP)",
    d: "M2550.6 1635.6h361.8c0-69.5 6.9-137.3 19.8-202.9l-354.9-70.4c-17.4 88.4-26.7 179.8-26.7 273.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aQ)",
    d: "m3563.4 668.8 203.5 501.6c30-12.2 61.5-21.6 94.1-27.8l-102-531.5c-67.8 12.9-133.1 32.4-195.6 57.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aR)",
    d: "m2994.5 1229.2 498.7 210.8c12.8-30.3 28.6-59.2 46.9-86.1l-448-303.8c-38.1 56.1-70.9 116-97.6 179.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aS)",
    d: "M4420.9 1446.9c12.2 30 21.5 61.5 27.8 94.1l531.5-102.1c-12.9-67.7-32.4-133.1-57.8-195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aT)",
    d: "M4151.2 1173.1c30.4 12.8 59.2 28.6 86.2 46.9l303.7-448c-56-38.1-115.9-70.901-179.1-97.601z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aU)",
    d: "m4371.2 1917.3 448.1 303.8c38-56.1 70.8-116 97.5-179.1l-498.6-210.8c-12.8 30.3-28.7 59.2-47 86.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aV)",
    d: "M2931.1 1832.2c13 67.8 32.4 133.2 57.8 195.6l501.5-203.5c-12.1-30-21.5-61.5-27.7-94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aW)",
    d: "m3424.8 327.1 136.8 337c62.7-25.4 128.4-45 196.5-58l-68.6-357.201c-91.7 17.5-180.2 43.901-264.7 78.201"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aX)",
    d: "m2655 1085.7 334.8 141.5c26.9-63.4 59.8-123.6 98.1-179.9l-300.9-204c-51.6 75.8-95.9 156.9-132 242.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aY)",
    d: "M4927.1 1241.5c25.5 62.7 45.1 128.4 58.1 196.5l357.1-68.6c-17.5-91.6-43.8-180.2-78.1-264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__aZ)",
    d: "M4364 669.8c63.5 26.8 123.6 59.799 180 97.999l204-300.9c-75.9-51.5-157-95.9-242.4-132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__ba)",
    d: "M2569 1901.8c17.5 91.7 43.8 180.2 78.1 264.6l337.1-136.7c-25.5-62.7-45-128.4-58.1-196.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bb)",
    d: "M3955.7 1131.1c33.6 0 66.3 3.4 98.1 9.6l105.8-533.501c-66-13-134.1-20-203.9-20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bc)",
    d: "M2907.3 1635.6h543.9c0-33.6 3.3-66.4 9.6-98.1l-533.5-105.8c-13 66-20 134.1-20 203.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bd)",
    d: "M4312.4 1278.9c23.2 23.2 44.2 48.8 62.6 76.2l452-302.5c-38.2-56.9-81.7-110-130-158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__be)",
    d: "m3214.3 894.3 384.7 384.6c23.2-23.3 48.7-44.2 76.1-62.6l-302.4-452c-57 38.1-110 81.7-158.4 130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bf)",
    d: "M4460.1 1635.6c0 33.6-3.3 66.4-9.6 98.1l533.6 105.8c13-65.9 19.9-134.1 19.9-203.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bg)",
    d: "M3084.3 2218.6c38.2 56.9 81.8 110 130 158.3l384.7-384.6c-23.3-23.2-44.2-48.8-62.6-76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bh)",
    d: "M6205.2 452.1c-15.5 7.6-21.9 26.2-14.4 41.7l15.6 32.1-32.1 15.6c-15.4 7.6-21.9 26.2-14.3 41.7 7.5 15.5 26.2 21.9 41.6 14.4l32.1-15.7 15.7 32.1c7.5 15.5 26.2 21.9 41.6 14.4 15.5-7.6 21.9-26.2 14.4-41.7l-15.6-32.1 32.1-15.6c15.4-7.6 21.9-26.2 14.3-41.7-7.5-15.5-26.2-21.9-41.6-14.4l-32.1 15.7-15.7-32.1c-5.4-11.1-16.5-17.5-28-17.5-4.6 0-9.3 1-13.6 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bi)",
    d: "M4781.4 554.1c-18.5 18.6-18.5 48.6 0 67.1 18.6 18.6 48.6 18.6 67.1 0 18.6-18.5 18.6-48.5 0-67.1-9.2-9.2-21.4-13.8-33.5-13.8-12.2 0-24.3 4.6-33.6 13.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5765.1 989.3c0-44.2 35.8-80.1 80.1-80.1 44.2 0 80.1 35.9 80.1 80.1 0 44.3-35.9 80.2-80.1 80.1-44.3 0-80.1-35.8-80.1-80.1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4608.5 689.6c30.4 0 58.7 11.9 79.8 33.4 21 21.4 32.6 49.899 32.6 80.399V1194.9h-6V803.399c0-60.4-46.7-107.799-106.4-107.799-59.6 0-106.3 47.399-106.3 107.799V957.1l.8 58.9c0 44.6-36.1 80.8-80.5 80.8-44.5 0-80.7-36.2-80.7-80.8v-81.101c0-59.5-49.1-107.899-109.5-107.899s-109.6 48.399-109.6 107.899v1.201l1.4 312.9h-6l-1.4-314.101c0-62.8 51.9-113.899 115.6-113.899s115.5 51.099 115.5 113.899V1016c0 41.3 33.5 74.8 74.7 74.8 41.1 0 74.5-33.5 74.5-74.8l-.8-58.9V803.399c0-30.5 11.6-58.999 32.6-80.399 21.1-21.5 49.4-33.4 79.7-33.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bj)",
    d: "M2468.82 175.296h472.32v484.8h-472.32z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bk)",
    d: "M2629.9 228.1c-4.7 4.7-4.7 12.399 0 17.099l56.5 56.5 3.6 3.601 4.7 4.7c3.3 3.3 3.3 8.599 0 11.899s-8.7 3.3-12 0l-4.2-4.299-82.6-82.6c-4.7-4.7-12.3-4.7-17.1 0-4.7 4.7-4.7 12.3 0 17l89 89 2.9 2.899c3.3 3.3 3.3 8.6 0 12-3.3 3.2-8.7 3.3-12 0l-4.5-4.599-110-110c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17l110 110 7.5 7.5c3.4 3.3 3.4 8.7 0 12a8.39 8.39 0 0 1-11.9 0l-2.1-2.101-77.1-77.199c-4.7-4.7-12.4-4.7-17.1 0s-4.7 12.4 0 17.1l68.1 68 3.5 3.599a8.39 8.39 0 0 1 0 11.901 8.39 8.39 0 0 1-11.9 0l-6.8-6.8-46.1-46.101c-4.7-4.7-12.3-4.7-17 0s-4.7 12.3 0 17L2690.5 537.5c36.7 36.7 96.2 36.7 132.9 0s36.7-96.2 0-132.9l-176.5-176.5c-2.3-2.3-5.4-3.5-8.5-3.5s-6.2 1.2-8.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2717.9 509.8c-21.5-21.5-21.5-56.3 0-77.8s56.3-21.5 77.8 0 21.5 56.3 0 77.8-56.3 21.5-77.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bl)",
    d: "M2737.7 451.8c-10.5 10.5-10.5 27.599 0 38.099 10.6 10.6 27.6 10.6 38.2 0 10.5-10.5 10.5-27.599 0-38.099-5.3-5.2-12.2-7.901-19.1-7.901s-13.8 2.701-19.1 7.901"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bm)",
    d: "m1610.7 1171.9 357.1 151.2 2.3-5.6-357-151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bn)",
    d: "m1912.6 1189.4 52.4 129.2-129.3 52.4 2.3 5.6 134.8-54.7-54.6-134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3169.9 892.4c-12.1 0-23.5-4.6-32.2-13l-194.7-187c-8.9-8.6-14-20.2-14.2-32.6-.3-12.4 4.3-24.1 12.9-33 8.8-9.2 20.7-14.3 33.5-14.3 12 0 23.4 4.6 32.1 13l194.7 187c18.4 17.8 19 47.2 1.3 65.6-8.8 9.2-20.7 14.3-33.4 14.3m-194.7-273.9c-11.1 0-21.5 4.4-29.2 12.4-7.4 7.8-11.4 18-11.2 28.8s4.6 20.9 12.4 28.3l194.7 187.1c7.5 7.3 17.5 11.3 28 11.3 11 0 21.4-4.4 29.1-12.4 15.4-16.1 14.9-41.7-1.2-57.1l-194.7-187.1c-7.5-7.3-17.5-11.3-27.9-11.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2708.8 828.2c0-51.3 41.7-93 93-93 51.4.1 93 41.7 93 93 0 51.4-41.6 93-93 93-51.3 0-93-41.6-93-93",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bo)",
    d: "M5296.5 254.199 5119.7 431.1c-11.2 11.2-16.8 25.899-16.8 40.599s5.6 29.401 16.8 40.601c22.4 22.4 58.8 22.4 81.2 0l176.9-176.8c22.4-22.5 22.4-58.801 0-81.301-11.2-11.2-25.9-16.8-40.6-16.8s-29.4 5.6-40.7 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bp)",
    d: "m5191.5 268.499-185.7 185.7c-11.2 11.2-16.8 25.9-16.8 40.6s5.6 29.4 16.8 40.6c22.5 22.4 58.8 22.4 81.2 0l185.7-185.6c22.4-22.5 22.4-58.8 0-81.3-11.2-11.2-25.9-16.8-40.6-16.8s-29.4 5.6-40.6 16.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bq)",
    fillRule: "evenodd",
    d: "M7597.5 1589.4c54.6 0 99.1 44.4 99.1 99.1 0 54.6-44.5 99.1-99.1 99.1h-418.6c-26.4 0-51.3-10.3-70-29-18.8-18.7-29.1-43.6-29.1-70.1s10.3-51.4 29.1-70.1c18.7-18.7 43.6-29 70-29zM7179 1781.6h418.5c51.4 0 93.2-41.8 93.2-93.1 0-51.4-41.8-93.1-93.2-93.1H7179c-24.9 0-48.2 9.7-65.8 27.2-17.6 17.6-27.3 41-27.3 65.9s9.7 48.2 27.3 65.8 40.9 27.3 65.8 27.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__br)",
    fillRule: "evenodd",
    d: "M1162.6 1569.2c54.7 0 99.1 44.5 99.1 99.1 0 54.7-44.4 99.2-99.1 99.2H744.1c-26.5 0-51.4-10.4-70.1-29.1s-29-43.6-29-70.1c0-26.4 10.3-51.3 29-70 18.7-18.8 43.6-29.1 70.1-29.1zM744 1761.5h418.6c51.3 0 93.1-41.8 93.1-93.2 0-51.3-41.8-93.1-93.1-93.1H744.1c-24.9 0-48.3 9.7-65.9 27.3s-27.3 41-27.3 65.8c0 24.9 9.7 48.3 27.3 65.9s41 27.3 65.8 27.3",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#etf-hero_svg__bs)",
    fillRule: "evenodd",
    d: "M6941.3 430.1c55.8 0 106.8 32.8 129.9 83.5 32.6 71.6.9 156.4-70.7 189.1L6447 954.899c-18.8 8.5-38.6 12.9-59.1 12.9-55.8 0-106.8-32.799-129.9-83.599-15.8-34.7-17.2-73.4-3.8-109.1 13.3-35.8 39.8-64.1 74.5-79.9L6882.2 443c18.8-8.6 38.6-12.9 59.1-12.9m-553.4 531.699c19.6 0 38.6-4.2 56.6-12.4L6998 697.2c68.6-31.3 99-112.5 67.8-181.1-22.2-48.6-71.1-80-124.5-80-19.6 0-38.6 4.099-56.6 12.299L6331.2 700.6c-33.3 15.2-58.6 42.3-71.4 76.6-12.8 34.2-11.5 71.3 3.6 104.5 22.2 48.6 71.1 80.099 124.5 80.099",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__b",
    x1: 6315.74,
    x2: 5747.85,
    y1: 1936.68,
    y2: 1368.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__c",
    x1: 6573.89,
    x2: 5988.87,
    y1: 2122,
    y2: 1536.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__d",
    x1: 1810.66,
    x2: 2217.86,
    y1: 1478.81,
    y2: 1886.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__e",
    x1: 1625.56,
    x2: 2045.04,
    y1: 1345.93,
    y2: 1765.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__f",
    x1: 6056.89,
    x2: 6741.51,
    y1: 520.233,
    y2: 776.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__g",
    x1: 3707.15,
    x2: 3955.66,
    y1: 495.892,
    y2: 495.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__h",
    x1: 2864.47,
    x2: 3263.51,
    y1: 894.908,
    y2: 894.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__i",
    x1: 4916.88,
    x2: 5273.88,
    y1: 1511.33,
    y2: 1511.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__j",
    x1: 4504.94,
    x2: 4887.79,
    y1: 743.927,
    y2: 743.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__k",
    x1: 2995.48,
    x2: 3521.74,
    y1: 1399.15,
    y2: 1399.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__l",
    x1: 3411.32,
    x2: 3778.59,
    y1: 986.342,
    y2: 986.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__m",
    x1: 4347.15,
    x2: 4862.7,
    y1: 1274.9,
    y2: 1274.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__n",
    x1: 4047.25,
    x2: 4336.92,
    y1: 938.534,
    y2: 938.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__o",
    x1: 4389.61,
    x2: 4915.84,
    y1: 1872.05,
    y2: 1872.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__p",
    x1: 3048.63,
    x2: 3564.18,
    y1: 1996.29,
    y2: 1996.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__q",
    x1: 2666.16,
    x2: 3056.47,
    y1: 1284.69,
    y2: 1284.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__r",
    x1: 4145.5,
    x2: 4467.66,
    y1: 541.259,
    y2: 541.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__s",
    x1: 3224.72,
    x2: 3588.74,
    y1: 620.874,
    y2: 620.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__t",
    x1: 4766.88,
    x2: 5173.94,
    y1: 1086.65,
    y2: 1086.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__u",
    x1: 4854.84,
    x2: 5245.15,
    y1: 1986.53,
    y2: 1986.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__v",
    x1: 3771.7,
    x2: 3955.67,
    y1: 916.982,
    y2: 916.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__w",
    x1: 3147.77,
    x2: 3623.58,
    y1: 1158.75,
    y2: 1158.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__x",
    x1: 4416.88,
    x2: 4931.67,
    y1: 1543.61,
    y2: 1543.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__y",
    x1: 4219.23,
    x2: 4645.81,
    y1: 1065.59,
    y2: 1065.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__z",
    x1: 4287.78,
    x2: 4763.58,
    y1: 2112.46,
    y2: 2112.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__A",
    x1: 2979.64,
    x2: 3494.46,
    y1: 1727.58,
    y2: 1727.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__B",
    x1: 3265.5,
    x2: 3692.08,
    y1: 2205.6,
    y2: 2205.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__C",
    x1: 3955.66,
    x2: 4228.98,
    y1: 421.371,
    y2: 421.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__D",
    x1: 2962.15,
    x2: 3375.47,
    y1: 682.82,
    y2: 682.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__E",
    x1: 4979.09,
    x2: 5360.72,
    y1: 1772.25,
    y2: 1772.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__F",
    x1: 4693.38,
    x2: 5123.5,
    y1: 848.763,
    y2: 848.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__G",
    x1: 2550.63,
    x2: 2932.23,
    y1: 1498.94,
    y2: 1498.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__H",
    x1: 3563.44,
    x2: 3861.05,
    y1: 890.719,
    y2: 890.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__I",
    x1: 2994.47,
    x2: 3540.09,
    y1: 1245.09,
    y2: 1245.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__J",
    x1: 4420.9,
    x2: 4980.2,
    y1: 1392.17,
    y2: 1392.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__K",
    x1: 4151.24,
    x2: 4541.12,
    y1: 947.22,
    y2: 947.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__L",
    x1: 4371.21,
    x2: 4916.82,
    y1: 2026.11,
    y2: 2026.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__M",
    x1: 2931.1,
    x2: 3490.44,
    y1: 1879.01,
    y2: 1879.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__N",
    x1: 3424.82,
    x2: 3758.07,
    y1: 456.53,
    y2: 456.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__O",
    x1: 2654.97,
    x2: 3087.9,
    y1: 1035.28,
    y2: 1035.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__P",
    x1: 4927.13,
    x2: 5342.32,
    y1: 1271.36,
    y2: 1271.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__Q",
    x1: 4364.01,
    x2: 4747.95,
    y1: 551.342,
    y2: 551.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__R",
    x1: 2568.99,
    x2: 2984.2,
    y1: 1999.82,
    y2: 1999.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__S",
    x1: 3955.67,
    x2: 4159.57,
    y1: 863.991,
    y2: 863.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__T",
    x1: 2907.31,
    x2: 3460.81,
    y1: 1533.65,
    y2: 1533.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__U",
    x1: 4312.39,
    x2: 4827,
    y1: 1124.67,
    y2: 1124.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__V",
    x1: 3214.35,
    x2: 3675.15,
    y1: 1021.57,
    y2: 1021.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__W",
    x1: 4450.5,
    x2: 5004.01,
    y1: 1737.56,
    y2: 1737.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__X",
    x1: 3084.33,
    x2: 3598.97,
    y1: 2146.51,
    y2: 2146.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__Y",
    x1: 6271.41,
    x2: 6229.81,
    y1: 472.619,
    y2: 593.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__Z",
    x1: 4814.99,
    x2: 4814.99,
    y1: 630.033,
    y2: 541.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ab",
    x1: 2522.73,
    x2: 2850.92,
    y1: 394.809,
    y2: 394.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ac",
    x1: 2756.79,
    x2: 2756.79,
    y1: 434.005,
    y2: 483.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ad",
    x1: 1610.73,
    x2: 1970.1,
    y1: 1244.73,
    y2: 1244.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ae",
    x1: 1835.74,
    x2: 1972.84,
    y1: 1281.84,
    y2: 1281.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__af",
    x1: 5102.9,
    x2: 5394.59,
    y1: 383.255,
    y2: 383.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ag",
    x1: 4989.01,
    x2: 5289.5,
    y1: 401.959,
    y2: 401.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ah",
    x1: 7079.83,
    x2: 7696.6,
    y1: 1688.49,
    y2: 1688.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ai",
    x1: 644.974,
    x2: 1261.74,
    y1: 1668.34,
    y2: 1668.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aj",
    x1: 6245.06,
    x2: 7084.06,
    y1: 698.917,
    y2: 698.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ak",
    x1: 6315.74,
    x2: 5747.85,
    y1: 1936.68,
    y2: 1368.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__al",
    x1: 6573.89,
    x2: 5988.87,
    y1: 2122,
    y2: 1536.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__am",
    x1: 1810.66,
    x2: 2217.86,
    y1: 1478.81,
    y2: 1886.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__an",
    x1: 1625.56,
    x2: 2045.04,
    y1: 1345.93,
    y2: 1765.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ao",
    x1: 6056.89,
    x2: 6741.51,
    y1: 520.233,
    y2: 776.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ap",
    x1: 3707.15,
    x2: 3955.66,
    y1: 495.892,
    y2: 495.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aq",
    x1: 2864.47,
    x2: 3263.51,
    y1: 894.908,
    y2: 894.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ar",
    x1: 4916.88,
    x2: 5273.88,
    y1: 1511.33,
    y2: 1511.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__as",
    x1: 4504.94,
    x2: 4887.79,
    y1: 743.927,
    y2: 743.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__at",
    x1: 2995.48,
    x2: 3521.74,
    y1: 1399.15,
    y2: 1399.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__au",
    x1: 3411.32,
    x2: 3778.59,
    y1: 986.342,
    y2: 986.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__av",
    x1: 4347.15,
    x2: 4862.7,
    y1: 1274.9,
    y2: 1274.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aw",
    x1: 4047.25,
    x2: 4336.92,
    y1: 938.534,
    y2: 938.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ax",
    x1: 4389.61,
    x2: 4915.84,
    y1: 1872.05,
    y2: 1872.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ay",
    x1: 3048.63,
    x2: 3564.18,
    y1: 1996.29,
    y2: 1996.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__az",
    x1: 2666.16,
    x2: 3056.47,
    y1: 1284.69,
    y2: 1284.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aA",
    x1: 4145.5,
    x2: 4467.66,
    y1: 541.259,
    y2: 541.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aB",
    x1: 3224.72,
    x2: 3588.74,
    y1: 620.874,
    y2: 620.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aC",
    x1: 4766.88,
    x2: 5173.94,
    y1: 1086.65,
    y2: 1086.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aD",
    x1: 4854.84,
    x2: 5245.15,
    y1: 1986.53,
    y2: 1986.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aE",
    x1: 3771.7,
    x2: 3955.67,
    y1: 916.982,
    y2: 916.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aF",
    x1: 3147.77,
    x2: 3623.58,
    y1: 1158.75,
    y2: 1158.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aG",
    x1: 4416.88,
    x2: 4931.67,
    y1: 1543.61,
    y2: 1543.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aH",
    x1: 4219.23,
    x2: 4645.81,
    y1: 1065.59,
    y2: 1065.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aI",
    x1: 4287.78,
    x2: 4763.58,
    y1: 2112.46,
    y2: 2112.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aJ",
    x1: 2979.64,
    x2: 3494.46,
    y1: 1727.58,
    y2: 1727.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aK",
    x1: 3265.5,
    x2: 3692.08,
    y1: 2205.6,
    y2: 2205.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aL",
    x1: 3955.66,
    x2: 4228.98,
    y1: 421.371,
    y2: 421.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aM",
    x1: 2962.15,
    x2: 3375.47,
    y1: 682.82,
    y2: 682.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aN",
    x1: 4979.09,
    x2: 5360.72,
    y1: 1772.25,
    y2: 1772.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aO",
    x1: 4693.38,
    x2: 5123.5,
    y1: 848.763,
    y2: 848.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aP",
    x1: 2550.63,
    x2: 2932.23,
    y1: 1498.94,
    y2: 1498.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aQ",
    x1: 3563.44,
    x2: 3861.05,
    y1: 890.719,
    y2: 890.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aR",
    x1: 2994.47,
    x2: 3540.09,
    y1: 1245.09,
    y2: 1245.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aS",
    x1: 4420.9,
    x2: 4980.2,
    y1: 1392.17,
    y2: 1392.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aT",
    x1: 4151.24,
    x2: 4541.12,
    y1: 947.22,
    y2: 947.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aU",
    x1: 4371.21,
    x2: 4916.82,
    y1: 2026.11,
    y2: 2026.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aV",
    x1: 2931.1,
    x2: 3490.44,
    y1: 1879.01,
    y2: 1879.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aW",
    x1: 3424.82,
    x2: 3758.07,
    y1: 456.53,
    y2: 456.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aX",
    x1: 2654.97,
    x2: 3087.9,
    y1: 1035.28,
    y2: 1035.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aY",
    x1: 4927.13,
    x2: 5342.32,
    y1: 1271.36,
    y2: 1271.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__aZ",
    x1: 4364.01,
    x2: 4747.95,
    y1: 551.342,
    y2: 551.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__ba",
    x1: 2568.99,
    x2: 2984.2,
    y1: 1999.82,
    y2: 1999.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bb",
    x1: 3955.67,
    x2: 4159.57,
    y1: 863.991,
    y2: 863.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bc",
    x1: 2907.31,
    x2: 3460.81,
    y1: 1533.65,
    y2: 1533.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bd",
    x1: 4312.39,
    x2: 4827,
    y1: 1124.67,
    y2: 1124.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__be",
    x1: 3214.35,
    x2: 3675.15,
    y1: 1021.57,
    y2: 1021.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bf",
    x1: 4450.5,
    x2: 5004.01,
    y1: 1737.56,
    y2: 1737.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bg",
    x1: 3084.33,
    x2: 3598.97,
    y1: 2146.51,
    y2: 2146.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bh",
    x1: 6271.41,
    x2: 6229.81,
    y1: 472.619,
    y2: 593.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bi",
    x1: 4814.99,
    x2: 4814.99,
    y1: 630.033,
    y2: 541.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bk",
    x1: 2522.73,
    x2: 2850.92,
    y1: 394.809,
    y2: 394.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bl",
    x1: 2756.79,
    x2: 2756.79,
    y1: 434.005,
    y2: 483.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bm",
    x1: 1610.73,
    x2: 1970.1,
    y1: 1244.73,
    y2: 1244.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bn",
    x1: 1835.74,
    x2: 1972.84,
    y1: 1281.84,
    y2: 1281.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bo",
    x1: 5102.9,
    x2: 5394.59,
    y1: 383.255,
    y2: 383.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB0A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bp",
    x1: 4989.01,
    x2: 5289.5,
    y1: 401.959,
    y2: 401.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA2D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A22664"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bq",
    x1: 7079.83,
    x2: 7696.6,
    y1: 1688.49,
    y2: 1688.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__br",
    x1: 644.974,
    x2: 1261.74,
    y1: 1668.34,
    y2: 1668.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "etf-hero_svg__bs",
    x1: 6245.06,
    x2: 7084.06,
    y1: 698.917,
    y2: 698.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43454B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2E35"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "etf-hero_svg__aa",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#etf-hero_svg__image0_4_637",
    transform: "scale(.00102 .00099)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "etf-hero_svg__bj",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#etf-hero_svg__image0_4_637",
    transform: "scale(.00102 .00099)"
  })))));
};
export default SvgEtfHero;